import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControlLabel, Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import classes from './Radio.module.scss';

interface RadioProps extends MuiRadioProps {
    label?: string;
}

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
    ({ label, className, ...props }, ref) => {
        return (
            <FormControlLabel
                label={label}
                control={
                    <MuiRadio
                        disableRipple
                        {...props}
                        inputRef={ref}
                        icon={<FontAwesomeIcon icon={faCircle} className={classes.icon} />}
                        checkedIcon={
                            <FontAwesomeIcon icon={faCircleCheck} className={classes.icon} />
                        }
                    />
                }
                className={clsx(classes.root, className)}
            />
        );
    }
);

Radio.displayName = 'Radio';
